import { SmsAuthenticationMethodConfiguration } from '@microsoft/microsoft-graph-types-beta';
import { AuthenticationMethodsSMSSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/sms/model';
import { updateAuthenticationMethodPolicyConfig } from 'projects/angular-clarity/src/app/stores/client/graph/authentication-methods-policies/actions';

export function remediate(
    _tenant: string,
    policy: SmsAuthenticationMethodConfiguration,
    schema: AuthenticationMethodsSMSSchema,
) {
    // If state is disabled, only update the state property
    if (schema.properties.state.const === 'disabled') {
        const updatedPolicy: SmsAuthenticationMethodConfiguration = {
            ...policy,
            state: schema.properties.state.const,
        };

        return updateAuthenticationMethodPolicyConfig({
            _tenant,
            policy: updatedPolicy,
        });
    }

    const updatedPolicy: SmsAuthenticationMethodConfiguration = {
        ...policy,
        state: schema.properties.state.const,
    };

    if (schema.properties.includeTargets.maxItems > 0) {
        updatedPolicy.includeTargets = schema.properties.includeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
                isUsableForSignIn: target.properties?.isUsableForSignIn?.const ?? false,
            };
        });
    } else {
        updatedPolicy.includeTargets = [];
    }

    if (schema.properties.excludeTargets.maxItems > 0) {
        updatedPolicy.excludeTargets = schema.properties.excludeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.excludeTargets = [];
    }

    return updateAuthenticationMethodPolicyConfig({
        _tenant,

        policy: updatedPolicy,
    });
}
